import { MasterDialog } from "#common/Dialog/Dialog"
import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import { COLOR_PRIMARY, COLOR_WHITE } from "#constants/Styles"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { jobProfileIdHistoryGet } from "#job-profile/services/api"
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings"
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd"
import DownhillSkiingIcon from "@mui/icons-material/DownhillSkiing"
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople"
import HandymanIcon from "@mui/icons-material/Handyman"
import PsychologyIcon from "@mui/icons-material/Psychology"
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred"
import SyncIcon from "@mui/icons-material/Sync"
import WorkIcon from "@mui/icons-material/Work"
import WorkOffIcon from "@mui/icons-material/WorkOff"
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium"
import { Box, Typography } from "@mui/material"
import Avatar from "@mui/material/Avatar"
import Divider from "@mui/material/Divider"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemAvatar from "@mui/material/ListItemAvatar"
import ListItemText from "@mui/material/ListItemText"
import * as React from "react"
import { Fragment, useMemo } from "react"

export default function HistoryDialog({ open, setOpen, profileData }) {
	const buttons = useMemo(
		() => [
			{
				label: "Cerrar",
				onClick: () => {
					setOpen(false)
				},
			},
		],
		[setOpen]
	)

	return (
		<Fragment>
			<MasterDialog
				{...{
					open,
					setOpen,
					title: (
						<>
							Historial de <strong>{profileData.nombre}</strong>
						</>
					),
					buttons,
					maxWidth: "md",
				}}
			>
				<HistoryProfile autoFetch={open} profileData={profileData} />
			</MasterDialog>
		</Fragment>
	)
}
export function HistoryProfile({ autoFetch, profileData }) {
	const params = useMemo(() => ({ id: profileData.id }), [profileData.id])
	const { data, loading, error } = useApi(jobProfileIdHistoryGet, {
		autoFetch,
		params,
	})
	const history = data?.data || []

	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse api={error} />

	if (history.length === 0)
		return (
			<Box
				sx={{ display: "flex", flexDirection: "column", gap: 2, alignItems: "center" }}
			>
				<Typography variant="h5">No hay historial</Typography>
			</Box>
		)

	return history.map((item) => {
		const action = item.action.toLowerCase()
		return (
			<>
				<List sx={{ width: "100%", bgcolor: "background.paper" }}>
					<ListItem alignItems="flex-start">
						<ListItemAvatar>
							<Avatar
								sx={{
									bgcolor: action.includes("eliminado")
										? "red"
										: action.includes("añadido")
										? "green"
										: COLOR_PRIMARY, // color de fondo (puedes usar theme.palette o un color fijo)
									color: COLOR_WHITE,
								}}
							>
								<IconHistory clave={action} />
							</Avatar>
						</ListItemAvatar>
						<ListItemText
							primary={item.created_at}
							secondary={
								<React.Fragment>
									<Typography
										sx={{ display: "inline" }}
										component="span"
										variant="body2"
										color="text.primary"
									>
										{item.created_by_name}
									</Typography>
									<br />
									{item.description}
								</React.Fragment>
							}
						/>
					</ListItem>
					<Divider variant="inset" component="li" />
				</List>
			</>
		)
	})
}

const IconHistory = ({ clave }) => {
	const items = [
		{
			icon: <AssignmentIndIcon />,
			key: "Creacion",
		},
		{
			icon: <AssignmentIndIcon />,
			key: "Creado",
		},
		{
			icon: <SyncIcon />,

			key: "Actualizado",
		},
		{
			icon: <WorkIcon />,
			key: "Activado",
		},
		{
			icon: <WorkOffIcon />,
			key: "Desactivado",
		},
		{
			icon: <WorkspacePremiumIcon />,
			key: "competencia",
		},
		{
			icon: <EmojiPeopleIcon />,
			key: "interacción",
		},
		{
			icon: <DownhillSkiingIcon />,
			key: "skill",
		},
		{
			icon: <AdminPanelSettingsIcon />,
			key: "responsabilidad",
		},
		{
			icon: <HandymanIcon />,
			key: "herramienta",
		},
		{
			icon: <PsychologyIcon />,
			key: "kpi",
		},
	]
	let icon = <ReportGmailerrorredIcon />
	items.forEach((item) => {
		if (clave.includes(item.key.toLowerCase())) icon = item.icon
	})
	return icon
}
